import { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom"
import Principal from './escortZone/Principal';
import 'react-toastify/dist/ReactToastify.css';
import './css/landing.css'
import './css/response.css'
import TrabajaConNosotros from './escortZone/TrabajaConNosotros';
import QuienesSomos from './escortZone/QuienesSomos';
import { Cargando } from './Cargando';
import logoIP from './img/logoInfernalParadise.png'

const LandingScorts = () => {

  const [cargando, setCargando] = useState(false)
  const [stateModalLegalIfo, setStateModalLegalIfo] = useState(true)
  const [openMenuHeader, setOpenMenuHeader] = useState(false)
  const [viewMenu, setViewMenu] = useState('PRINCIPAL');
  const [openMenuFilter, setOpenMenuFilter] = useState(false)

  useEffect(() => {
    const acceptTerms = sessionStorage.getItem('acceptTerms')
    if (!!acceptTerms) {
      setStateModalLegalIfo(false)
    }
  }, [])

  const actionAceptLegalInfo = () => {
    sessionStorage.setItem('acceptTerms', true)
    setStateModalLegalIfo(false)
  }

  const redirectView = (view) => {
    setOpenMenuHeader(false)
    setViewMenu(view);
  }

  const validateRedirect = () => {
    switch (viewMenu) {
      case 'PRINCIPAL':
        return (
          <Principal toast={toast} openMenuFilter={openMenuFilter} setOpenMenuFilter={setOpenMenuFilter} setCargando={setCargando} />
        )
      case 'TRABAJA_CON_NOSOTROS':
        return (
          <TrabajaConNosotros />
        )
      case 'QUIENES_SOMOS':
        return (
          <QuienesSomos />
        )
      case 'OFERTAS_EXCLUSIVAS':
        return (
          <></>
        )
      default:
        return (
          <></>
        )
    }
  }

  return (
    <>
      <ToastContainer autoClose={4000} hideProgressBar={true} />
      <div className='div-banner-padre'>
        <div className='div-banner-header' >
          <div className='div-banner-header-hijo' >
            <div className={viewMenu === 'PRINCIPAL' ? 'div-menu-element-item-active' : 'div-menu-element-item'} onClick={() => redirectView('PRINCIPAL')}>PRINCIPAL</div>
            <div className={viewMenu === 'TRABAJA_CON_NOSOTROS' ? 'div-menu-element-item-active' : 'div-menu-element-item'} onClick={() => redirectView('TRABAJA_CON_NOSOTROS')}>CASTING</div>
            <div className={viewMenu === 'QUIENES_SOMOS' ? 'div-menu-element-item-active' : 'div-menu-element-item'} onClick={() => redirectView('QUIENES_SOMOS')}>QUIENES SOMOS</div>
            <div className={viewMenu === 'PRINCIPAL' ? openMenuFilter ? 'div-icon-filters-active' : 'div-icon-filters' : 'div-icon-filters-not-valide'} onClick={() => setOpenMenuFilter(!openMenuFilter)}>
              <FontAwesomeIcon className={viewMenu === 'PRINCIPAL' ? 'icon-fa-bars' : 'div-icon-filters-not-valide'} icon={faMagnifyingGlass} style={{ marginRight: "5px" }} />
              <p>Buscar</p>
            </div>
          </div>
        </div>
        <div className='div-banner-header-response' >
          <div className='div-banner-header-response-hijo' >
            <div className='div-img-ip-response'>
              <img src={logoIP} alt='' className='img-ip-response' ></img>
            </div>
            <FontAwesomeIcon className={viewMenu === 'PRINCIPAL' ? openMenuFilter ? 'icon-fa-bars-active' : 'icon-fa-bars' : 'div-icon-filters-not-valide'} icon={faMagnifyingGlass} onClick={() => setOpenMenuFilter(!openMenuFilter)} />
            <FontAwesomeIcon className={openMenuHeader ? 'icon-fa-bars-active' : 'icon-fa-bars'} icon={faBars} onClick={() => setOpenMenuHeader(!openMenuHeader)} />
          </div>
        </div>
        <div className='div-menu-active'>
          <div className={openMenuHeader ? 'div-menu-element' : 'div-menu-element-off'} >
            <div className={viewMenu === 'PRINCIPAL' ? 'div-menu-element-item-responsive-active' : 'div-menu-element-item-responsive'} onClick={() => redirectView('PRINCIPAL')}>PRINCIPAL</div>
            <div className={viewMenu === 'TRABAJA_CON_NOSOTROS' ? 'div-menu-element-item-responsive-active' : 'div-menu-element-item-responsive'} onClick={() => redirectView('TRABAJA_CON_NOSOTROS')}>CASTING</div>
            <div className={viewMenu === 'QUIENES_SOMOS' ? 'div-menu-element-item-responsive-active' : 'div-menu-element-item-responsive'} onClick={() => redirectView('QUIENES_SOMOS')}>QUIENES SOMOS</div>
          </div>
        </div>
      </div>
      {
        validateRedirect()
      }
      {
        stateModalLegalIfo ?
          <div className='div-cargando-active'>
            <div className='div-gift-element'>
              <div className='div-modal-info-legal'>
                <h3 className='mb-3'>Contenido exclusivo para adultos</h3>
                <p className='mb-3'>Esta web es para mayores de 18 años.</p>
                <p className='mb-3'>Utilizamos cookies propias para recordar tus preferencias y facilitarte la navegación. Las cookies de Google son anónimas y
                  no compartimos los datos con terceros. Puedes obtener más información en nuestra distibución de políticas.</p>
                <div className='div-links-modal-info-legal'>
                  <Link className='btn btn-link' target='_blank' to="/politicaCookies">Política de Cookies</Link>
                  <Link className='btn btn-link' target='_blank' to="/politicaPrivacidad">Política de privacidad</Link>
                </div>
                <div className='div-links-modal-info-legal'>
                  <Link className='btn btn-link' target='_blank' to="/controlParental">Control parental</Link>
                </div>
                <div className='div-botom-modal-info-legal'>
                  <button className='btn btn-link btn-close-modal' onClick={() => actionAceptLegalInfo()} >Aceptar</button>
                </div>
              </div>
            </div>
          </div>
          :
          <> </>
      }
      {
        cargando ?
          <Cargando />
          :
          <></>
      }
    </>
  )
}

export default LandingScorts
